import React from "react";
import { Provider } from "react-redux";
import { GlobalProvider } from "./src/context/GlobalContext";
import { CartProvider } from "./src/context/CartContext";
import { AuthProvider } from "./src/context/AuthContext";
import { UserPlanProvider } from "./src/context/UserPlanContext";
import Layout from "./src/components/Layout";
import Tender360SessionBoundary from "./src/store/Tender360SessionBoundary";
import { tender360Store } from "./src/store/tender360Store";

export const wrapPageElement = ({ element, props }) => {
  // props provide same data to Layout as Page element will get
  // including location, data, etc - you don't need to pass it
  return <Layout {...props}>{element}</Layout>;
};

export const wrapRootElement = ({ element }) => (
  <Provider store={tender360Store}>
    <GlobalProvider>
      <AuthProvider>
        <UserPlanProvider>
          <Tender360SessionBoundary>
            <CartProvider>{element}</CartProvider>
          </Tender360SessionBoundary>
        </UserPlanProvider>
      </AuthProvider>
    </GlobalProvider>
  </Provider>
);

export const onClientEntry = () => {
  if (typeof window !== "undefined" && "scrollRestoration" in window.history) {
    window.history.scrollRestoration = "manual";
  }
};

export const shouldUpdateScroll = ({
  routerProps: { location },
  getSavedScrollPosition,
}) => {
  // Check if user pressed BACK or FORWARD
  const isBack = location.action === "POP";
  const savedPosition = getSavedScrollPosition(location);

  if (isBack && savedPosition) {
    // Wait for layout to finish
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        window.scrollTo(savedPosition[0], savedPosition[1]);
      });
    });

    return false;
  }

  // For normal navigation → do NOT restore bottom, scroll to top
  window.scrollTo(0, 0);
  return false;
};


